import { createSelector, createStructuredSelector } from 'reselect';
import { StateProps } from './interface';
import { initialState } from './reducer';
import { Namespace } from '../../enum';
import { RootState } from '../../interface';

/* istanbul ignore next */
const selectState = (state: RootState) => state[Namespace.APP] || initialState;

export const selectLoading = () => createSelector(selectState, (state: StateProps) => state.loading);
export const selectError = () => createSelector(selectState, (state: StateProps) => state.error);
export const selectFormData = () => createSelector(selectState, (state: StateProps) => state.formData);
export const selectResponseData = () =>
    createSelector(selectState, (state: StateProps) => state.responseData);
export const selectCaptcha = () => createSelector(selectState, (state: StateProps) => state.captcha);
export const selectAddress = () => createSelector(selectState, state => state.address);

export const mapStateToProps = createStructuredSelector({
    loading: selectLoading(),
    error: selectError(),
    formData: selectFormData(),
    responseData: selectResponseData(),
    captcha: selectCaptcha(),
    address: selectAddress(),
});

export type State = ReturnType<typeof mapStateToProps>;
